export const katarzynaWolska = {
    'firstName': 'Katarzyna',
    'lastName': 'Wolska',
    'mydrId': 'katarzynawolska',
    'profession': 'Psychiatra',
    'avatar': 'female-avatar.webp',
    'slug': 'psychiatra-katarzyna-wolska',
    'locations': ['bydgoszcz'],
    'services': [
        ['psychiatry', 'adult'],
    ]
}